import { HudIcon, IconType } from '@hud/web-components/Icons/HudIcons';
import Button from '@hud/web-components/DesignSystem/Components/Button/Button';
import Container from './UpsaleCard.styles'

type UpsaleCardProps = {
  icon: IconType;
  caption: string;
  buttonText: string;
  url: string;
  openExternal?: boolean;
}

export default function UpsaleCard({
    icon,
    caption,
    buttonText,
    url,
    openExternal = false,
    } : UpsaleCardProps) {
  return (
    <Container>
      <div className="icon">
        <HudIcon icon={icon} size="20px" />
      </div>
      <div className="content">
        <p>{caption}</p>
        <Button href={url}
                size="tiny"
                target={openExternal ? '_blank' : '_self'}
                skin="upsell">
          {buttonText}
          <HudIcon icon="designSystem.arrowUpRightSmall" size="20px" />
        </Button>
      </div>
    </Container>
  );
};
